import { get } from "jquery";

interface Group {
    company_group_id: string;
    company_group_name: string;
    company_name_short: string;
    company_name: string;
    company_id: string;
}

class TMSUserEntity {
    analytics_user_id: string;
    user_type: string;
    user_role: string;
    user_id: string;
    use_sso_login: string;
    use_sso_domain: null;
    group_id: string;
    group_driver: string;
    group_name: string;
    company_id: string;
    group_admin: string;
    group_biller: string;
    group_act_sup: string;
    corp_admin: string;
    group_customer: string;
    parent_group_id: string;
    company_name: string;
    corporation_id: string;
    site_offline: string;
    user_password_expire: string;
    password_expire: number;
    group: Group[] = [];
    GroupDispatch: number;
    GroupBiller: number;
    search_bar_trucking: number;
    search_bar_drayage: number;
    user_mobile: string;
    user_username: string;
    user_email: string;
    user_firstname: string;
    user_lastname: string;
    user_warehouse: string;
    user_developer: string;
    user_project: string;
    user_employee: string;
    user_payroll: string;
    user_timezone: string;
    user_theme: string;
    user_subtheme: string;
    fk_warehouse_id: null;
    file_thumbnail_url: null;
    user_firstlast: string;
    timezone: string;
    theme: string;
    subTheme: string;
    SERVER_ADDR: string;
    GroupActSup: number;
    authorized: number;
    current_file_name: string;
    page_allowed: number;
    is_vendor: number;
    is_claims_access: number;

    constructor(partial: Partial<TMSUserEntity>) {
        Object.assign(this, partial);
    }

    get isShipperOrConsignee() {
        const groups = new Map(this.group.filter(g => g.company_id === '26' || g.company_id === '23').map(i => [i.company_group_id, i]));
        const group = groups.get(this.group_id);
        if (!group) {
            return false;
        }

        return (
            group.company_group_name.includes('Shipper') ||
            group.company_group_name.includes('Consignee')
        );
    }

    get isAdmin() {
        const groups = new Map(this.group.filter(g => g.company_id === '26' || g.company_id === '23').map(i => [i.company_group_id, i]));
        const group = groups.get(this.group_id);
        if (!group) {
            return false;
        }

        return /admin/i.test(group.company_group_name);
    }

    get isSBCust() {
        return this.group.some(g =>
            (g.company_id === '26' || g.company_id === '23') &&
            (g.company_group_name.toUpperCase() === 'CUST' ||
                g.company_group_name.toUpperCase() === 'SB CUST')
        );
    }

    get isVendor() {
        return !!this.is_vendor;
    }

    get isClaimsAccess() {
        return this.is_claims_access;
    }
}

export { TMSUserEntity };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/store/login/tms_user_entity.ts